import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { FeatureName, useFeatureFlag } from '@/context/FeatureToggleContext/FeatureToggleContext';
import NotFound from '@/pages/NotFound/NotFound';

interface FeatureFlagRouteProps {
  feature: FeatureName;
}

const FeatureFlagRoute: FC<FeatureFlagRouteProps> = ({ feature }) => {
  const isEnabled = useFeatureFlag(feature);

  if (!isEnabled) {
    return <NotFound />;
  }

  return <Outlet />;
};

export default FeatureFlagRoute;
